import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-h5" }, "Law Firms", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_accounts_table = _resolveComponent("accounts-table")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-px-md" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_accounts_table, {
        "account-type": _ctx.accountType,
        class: "q-my-md"
      }, null, 8, ["account-type"])
    ]),
    _: 1
  }))
}